<mat-form-field appearance="outline">
  <mat-label>{{ field.key | translate }}</mat-label>
  <mat-select [multiple]="field.controlType === 'ddlMultiple'"
              [formControl]="field.control"
              [transform]="toDbModel.bind(this)">
    <mat-select-trigger *ngIf="field.controlType === 'ddlMultiple'">
      {{ ddlMultipleText }}
      <span *ngIf="(field.control.value?.length || 0) > 1"
            class="additional-selection">
        (+{{ (field.control.value?.length || 0) - 1 }})
      </span>
    </mat-select-trigger>
    <mat-option *ngFor="let item of selectItems$ | async" [value]="item">
      {{ item.text }}
    </mat-option>
  </mat-select>
  <mat-icon matSuffix
            class="clear"
            (click)="clearInput()"
            *ngIf="canShowClearBtn()">
    clear
  </mat-icon>
</mat-form-field>
